import React, { useEffect, useState } from "react"
import { Card, Button, Alert, ListGroup, Table } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { getExistingRides, getRidesAsPassenger } from "../contexts/RidesContext";
import { BsFillInfoCircleFill } from "react-icons/bs";



export default function Carpool() {
  const [error] = useState("")
  const [rides, setRides] = useState([])
  const [asPassenger, setAsPassenger] = useState([])
  const { currentUser } = useAuth()

  useEffect(()=>{
    const fetchRides = async () => {
      const result = await getExistingRides(currentUser)
      setRides(result)
    }
    fetchRides().catch(console.error);
  }, [rides.docs]);

  useEffect(()=>{
    const fetchPassengerRides = async () => {
      const result = await getRidesAsPassenger(currentUser)
      setAsPassenger(result)
    }
    fetchPassengerRides().catch(console.error);
  }, [rides.docs]);

  return (
    <>
      <style type="text/css">
        {`
    .btn-flat {
      background-color: purple;
      color: white;
    }

    .btn-xxl {
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      <Card className="text-center" style={{ width: '40rem' }}>
        <Card.Header>Taugethere Carpool</Card.Header>
        <ListGroup variant="flush">
          <ListGroup.Item>
            Press to create a ride, join a ride or inspect your existing rides
          </ListGroup.Item>
          <ListGroup.Item>
            {error && <Alert variant="danger">{error}</Alert>}
            <div>Logged in email: {currentUser.email}</div>
          </ListGroup.Item>
        </ListGroup>
        <Card.Body>
          <div className="mb-2">
            <Button size="xxl" href="/new-ride">
              Create a ride
            </Button>{'     '}
            <Button size="xxl" href="/join-ride">
              Join a Ride
            </Button>
          </div>
        </Card.Body>
        <ListGroup variant="flush">
          <ListGroup.Item>
            Rides you are the Driver in
          </ListGroup.Item>
          <ListGroup.Item>
            <Table striped hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Course</th>
                  <th>Time</th>
                  <th>Info</th>
                </tr>
              </thead>
              <tbody>
                {
                  rides && rides.map((ride, index) => {
                    return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{ride['name']}</td>
                          <td>{ride['time'].toDate().toDateString()}</td>
                          <td>
                            <a href={`/ride-page-driver/${ride['id']}`}><BsFillInfoCircleFill/></a>
                          </td>
                        </tr>
                      )})
                }
              </tbody>
            </Table>
          </ListGroup.Item>
          <ListGroup.Item>
            In these rides you can relax as a passenger
          </ListGroup.Item>
          <ListGroup.Item>
            <Table striped hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Course</th>
                  <th>Time</th>
                  <th>Info</th>
                </tr>
              </thead>
              <tbody>
                {
                  asPassenger && asPassenger.map((ride, index) => {
                    return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{ride['name']}</td>
                          <td>{ride['time'].toDate().toDateString()}</td>
                          <td>
                            <a href={`/ride-page-passenger/${ride['id']}`}><BsFillInfoCircleFill/></a>
                          </td>
                        </tr>
                      )})
                }
              </tbody>
            </Table>
          </ListGroup.Item>
          <ListGroup.Item>
            <Button href="/update-profile">
              Update Profile
            </Button>
          </ListGroup.Item>
        </ListGroup>
      </Card>
    </>
  )
}
